import * as Yup from 'yup';

const INITIAL_VALUES = {
  addLocation: '',
  line1: '',
  line2: '',
  city: '',
  state: '',
  zip: '',
  independent: 'false',
  purchasingLimitIndependent: '',
  purchasingLimitDependent: ''
};

const VALIDATION_SCHEMA = (pageLanguageContents, locationType, loadResponse) => {
  let schemaAttributes
    if (loadResponse.response && loadResponse.response.listCorporateLocations && loadResponse.response.listCorporateLocations[0].adminPaymentMode === "INDEPENDENT") {
      schemaAttributes = {
        addLocation: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[0]?.LocationReq),
        line1: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[1]?.AddressReq),
        city: Yup.string().required(pageLanguageContents?.ErrorValidations[2]?.CityReq),
        state: Yup.string().required(pageLanguageContents?.ErrorValidations[3]?.StateReq),
        zip: Yup.string()
          .min(5, pageLanguageContents?.ErrorValidations[4]?.TooShort)
          .required(pageLanguageContents?.ErrorValidations[5]?.ZipReq),
      }
    } else {
      schemaAttributes = {
        addLocation: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[0]?.LocationReq),
        line1: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[1]?.AddressReq),
        city: Yup.string().required(pageLanguageContents?.ErrorValidations[2]?.CityReq),
        state: Yup.string().required(pageLanguageContents?.ErrorValidations[3]?.StateReq),
        zip: Yup.string()
          .min(5, pageLanguageContents?.ErrorValidations[4]?.TooShort)
          .required(pageLanguageContents?.ErrorValidations[5]?.ZipReq),
        purchasingLimitDependent: loadResponse.response && loadResponse.response.listCorporateLocations && loadResponse.response.listCorporateLocations[0].adminPaymentMode !== "INDEPENDENT" && locationType === 'independentLocation' ? Yup.string().required(pageLanguageContents?.ErrorValidations[10]?.PurchasingLimitReq) : ''
      }
    }
  return Yup.object().shape(schemaAttributes);
}

export { INITIAL_VALUES, VALIDATION_SCHEMA };
